import httpRequest from '@/utils/request';

type IModuleType =
  | 'Issue'
  | 'Module'
  | 'Payment'
  | 'Quotation'
  | 'Requirement'
  | 'Todo';
const addLabels = (
  url: string,
  labelIds: string[],
): Promise<IResponseData.IBaseData> => {
  return httpRequest.post(url, labelIds);
};
const delLabels = (
  url: string,
  labelIds: string[],
): Promise<IResponseData.IBaseData> => {
  return httpRequest.delete(url, {
    data: labelIds,
  });
};
export const createLabelUrl = (moduleType: IModuleType, mId: string) => {
  return `/${moduleType}/${mId}/labels`;
};
export const requestAddLabels = (
  url: string,
  labelIds: string[],
): Promise<string> => {
  return new Promise((reslove, reject) => {
    addLabels(url, labelIds)
      .then((res) => {
        reslove(res.message);
      })
      .catch((error) => {
        reject(error.message);
      });
  });
};
export const requestDeleteLabels = (
  url: string,
  labelIds: string[],
): Promise<string> => {
  return new Promise((reslove, reject) => {
    delLabels(url, labelIds)
      .then((res) => {
        reslove(res.message);
      })
      .catch((error) => {
        reject(error.message);
      });
  });
};
